import { useContext } from 'react'

import context from './context'

export const useLoading = () => useContext(context)
